var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddlogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49985 12.899C2.75689 12.1399 2.19642 11.2217 1.86089 10.214C1.52535 9.20618 1.42356 8.13526 1.56321 7.08232C1.70287 6.02938 2.08031 5.02202 2.66695 4.13655C3.25358 3.25109 4.03403 2.51074 4.94918 1.97157C5.86433 1.43241 6.89018 1.10857 7.94902 1.0246C9.00786 0.940622 10.0719 1.09871 11.0606 1.48688C12.0493 1.87505 12.9367 2.48313 13.6556 3.26506C14.3745 4.04698 14.906 4.98225 15.2099 6.00002H16.9999C17.9654 5.99991 18.9053 6.31034 19.6808 6.88546C20.4564 7.46058 21.0264 8.26988 21.3066 9.19383C21.5869 10.1178 21.5625 11.1074 21.2372 12.0164C20.9118 12.9254 20.3027 13.7057 19.4999 14.242M11.4999 10V19",
    stroke: "#838383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14L11.5 10L7.5 14",
    stroke: "#838383",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddlogoIcon);
export default __webpack_public_path__ + "static/media/addlogoIcon.d459b59790377a0b4fd220ea8024ad46.svg";
export { ForwardRef as ReactComponent };